import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { find } from "lodash";
import moment from "moment";
import { Grid, Table, TableHead, TableRow, TableCell, TableBody, Box, Checkbox } from "@material-ui/core";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

// app
import {
  updateSession,
  openSnackbar,
  closeSnackbar
} from "../../store/action-creators";
// containers
import AppContainer from "../../containers/App";
import ProfileContainer from "../../containers/Profile";
// components
import IconButton from "../../components/buttons/IconButton";
import AddressSearch from '../../components/site/AddressSearch';
import Loading from '../../components/site/Loading';
import MessageBar from '../../components/message/MessageBar';
// entities
import { Auth, Session } from "../../entities/auth";
import { Message, emptyMessage, MessageTypes } from "../../entities/site";
import { Payment } from "../../entities/payment";
import { Address, AddressSetting, emptyAddressSetting } from "../../entities/home";
import { Mortgage, UserRate } from "../../entities/profile";
import ActionButton from "src/components/buttons/ActionButton";

import AuthService from '../../services/auth';

const states = [
  "Alabama",
  "Alaska",
  "American Samoa",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "District of Columbia",
  "Federated States of Micronesia",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Marshall Islands",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Northern Mariana Islands",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Palau",
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virgin Island",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming"
];

const styles: any = {
  container: {
    flex: 1,
    height: "100%",
    minHeight: "100%",
    marginBottom: 200,
    marginTop: 40
  },
  pageTitleSub: {
    textAlign: "left",
    fontSize: 18,
    fontWeight: 700,
    marginTop: 20,
    marginBottom: 40
  },
  input: {
    marginTop: 10
  },
  sectionTitle: {
    textAlign: "left",
    fontSize: 14
  },
  mortgageContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: 20,
    border: "1px solid #F1F1F1"
  },
  mortgage: {
    textAlign: "left"
  },
  footerContainer: {
    marginTop: 40,
    borderTop: "1px solid #CCCCCC",
    paddingTop: 10
  },
  divider: {
    marginTop: 10,
    marginBottom: 10,
    height: 5,
    backgroundColor: '#ccc'
  }
};

interface ProfilePublicPageProps {
  auth: Auth;
  history: any;
  session: Session;
  openSnackbar(msg: string): void;
  closeSnackbar(): void;
  updateSession(session: Session): void;
}

interface ProfilePublicPageState {
  loading: boolean;
}

class ProfilePublicPage extends Component<ProfilePublicPageProps, ProfilePublicPageState> {
  constructor(props: ProfilePublicPageProps) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  componentDidMount = () => {
    this.fetchUserData();
  };

  fetchUserData = async () => {

    try {

      // this.setState({ loading: true });
      // const addresses = await axios.get(`${AuthService.getApiUrls().home}/address/user/${this.props.auth.id}`);
      // const paymentRes = await axios.get(`${AuthService.getApiUrls().payment}/payments/user/${this.props.auth.id}`);
      // this.setState({
      //   loading: false,
      //   addresses: addresses.data,
      //   payments: paymentRes.data
      // });

    } catch (error) {
      console.log('error', error);
    }

  }

  handleNavigate = () => {
    // navigate
  };


  render() {
    return (
      <AppContainer loading={this.state.loading} private maxWidth="lg">
        <ProfileContainer>
          <Loading open={this.state.loading} />
          {/* <MessageBar message={this.state.message} /> */}
          <Grid container>
            <Grid item xs={10}>
              <div className="title">Profile Page</div>
            </Grid>
            
          </Grid>
        </ProfileContainer>
      </AppContainer>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.auth,
    session: state.session.session
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    { updateSession, openSnackbar, closeSnackbar },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(ProfilePublicPage));



// WEBPACK FOOTER //
// ./src/pages/profile/ProfilePublic.tsx